export default {
  replaceTaskDossierComments(rootState, comments) {
    rootState.taskDossier.taskDossier.comments = comments
  }
}
